/* src/app/app.component.scss */
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.card {
  width: 500px;
  display: block;
}
::ng-deep .p-button:focus {
  box-shadow: none !important;
}
::ng-deep .btn-primary {
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
  border: none;
  color: #0F172A;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 15px;
}
::ng-deep .btn-secondary {
  border: none;
  color: #0F172A;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 15px;
}
::ng-deep .btn-primary:hover {
  background:
    linear-gradient(
      135deg,
      #FFA500,
      #FFD700);
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 215, 0, 0.4);
}
::ng-deep .btn-primary:focus {
  border-color: #ff8c00;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px #F4EBFF !important;
}
::ng-deep .p-inputtext:not(textarea),
::ng-deep .p-dropdown {
  height: 44px !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.02);
  border-radius: 8px;
}
::ng-deep .p-datatable-wrapper {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.02);
}
::ng-deep .sortalticon.p-element.p-icon-wrapper {
  width: 12px !important;
  height: 12px !important;
  font-size: 12px !important;
}
::ng-deep .p-component,
::ng-deep textarea::placeholder {
  font-family: "Hanken Grotesk", sans-serif;
}
:root {
  --font-family-main: "Hanken Grotesk", sans-serif !important;
}
::ng-deep .p-dropdown-items-wrapper {
  margin-top: 4px;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 4px 8px;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background 0.2s ease;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #D47500;
  background: #FFC680;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
  background: #FFF1E0;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
}
::ng-deep .p-dropdown:focus {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
  background-color: white !important;
}
::ng-deep .p-dropdown:hover-visible {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .p-dropdown:hover {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep input:hover,
input:focus {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: black !important;
}
::ng-deep .p-dropdown.p-focus,
::ng-deep .p-dropdown.p-highlight,
::ng-deep .p-dropdown:focus-within {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep input .p-focus,
::ng-deep input .p-highlight {
  border-color: orange !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .formly-validation-message {
  color: #e24c4c;
  font-weight: bold;
  margin-top: 4px;
}
::ng-deep .p-error {
  color: #e24c4c;
  margin-top: 4px;
}
::ng-deep .btn-danger {
  background:
    linear-gradient(
      135deg,
      #FF4D4F,
      #FF7A7A);
  border: none;
  color: #fff;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
}
::ng-deep .btn-danger:hover {
  background:
    linear-gradient(
      135deg,
      #FF7A7A,
      #FF4D4F);
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 77, 79, 0.4);
}
::ng-deep .btn-danger:focus {
  border-color: #ff4d4f;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px rgba(255, 77, 79, 0.4) !important;
}
::ng-deep .btn-cancel {
  background: #f1f1f1;
  border: 1px solid #d0d0d0;
  color: #333;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
}
::ng-deep .btn-cancel:hover {
  background: #e0e0e0;
  color: #111;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
::ng-deep .btn-cancel:focus {
  border-color: #999;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px rgba(200, 200, 200, 0.4) !important;
}
::ng-deep .p-datepicker {
  width: 300px !important;
  height: 335px !important;
  font-size: 12px;
  overflow: hidden;
}
::ng-deep .p-datepicker-group {
  flex-direction: column !important;
  width: 100% !important;
}
::ng-deep .p-datepicker-calendar {
  table-layout: fixed;
  width: 100% !important;
  font-size: 12px;
}
::ng-deep .p-datepicker td,
::ng-deep .p-datepicker th {
  padding: 0.25rem !important;
  text-align: center;
}
::ng-deep .p-datepicker-header {
  padding: 0.5rem;
  font-size: 13px;
}
/*# sourceMappingURL=app.component-QR4SZARH.css.map */
